import React from "react";
import { useState } from "react";
import "./Header.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBed, faCalendar, faFemale } from "@fortawesome/free-solid-svg-icons";
import "../../search/Search.jsx";
//phần nâng cao
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css"; // Import styles
import "react-date-range/dist/theme/default.css"; // Import theme
const Header = () => {
  const [openCalendar, setOpenCalendar] = useState(false);
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const handleDateChange = (ranges) => {
    setDateRange([ranges.selection]);
  };

  const handleSearch = (event) => {
    event.preventDefault();
    window.location.replace("/search");
  };
  return (
    <header className="header">
      <h1 className="h1-header"> A lifetime of discounts? It's Genius.</h1>
      <p className="text-header">
        Get rewarded for your travels - unlock instant savings of 10% or more
        with a free account
      </p>
      <div>
        <button className="singin-button">Sign in / Register</button>
      </div>
      <div className="search-container">
        <div>
          <FontAwesomeIcon icon={faBed} className="icon-search" />
          <input
            type="text"
            placeholder="Where are you going?"
            className="input-location input-fail"
          />
        </div>

        <div onClick={() => setOpenCalendar(!openCalendar)}>
          <FontAwesomeIcon icon={faCalendar} className="icon-search" />
          <input
            type="text"
            placeholder={`${dateRange[0].startDate.toLocaleDateString()} to ${dateRange[0].endDate.toLocaleDateString()}`}
            className="input-date input-fail"
            readOnly
          />
        </div>

        <div>
          <FontAwesomeIcon icon={faFemale} className="icon-search" />
          <input
            type="text"
            placeholder="1 adult . 0 children . 1 room"
            className="input-member input-fail"
          />
        </div>
        <div>
          <button onClick={handleSearch} className="search-button">
            Search
          </button>
        </div>
      </div>

      {openCalendar && (
        <div className="date-range-modal">
          <DateRange
            editableDateInputs={true}
            onChange={handleDateChange}
            moveRangeOnFirstSelection={false}
            ranges={dateRange}
            minDate={new Date()}
          />
          <button onClick={() => setOpenCalendar(false)}>Close</button>
        </div>
      )}
    </header>
  );
};

export default Header;
